import { LinkButton, LocalizedPageTitle, OptimusProvider } from '@mews-commander/ui';
import { Banner, IconName, Stack } from '@optimus-web/core';
import { LocalizedText, useToggle } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { NewPublicFormWrapper } from '../style';
import { SetPasswordForm } from './SetPasswordForm';

export const SetPassword = () => {
    const [isSetSuccess, setIsSetSuccess] = useToggle();

    return (
        <NewPublicFormWrapper vertical>
            <OptimusProvider density="spacious">
                <Stack spacing="500" vertical>
                    {isSetSuccess ? (
                        <>
                            <LocalizedPageTitle textKey={TextKey.PasswordChanged} />
                            <Banner
                                variant="success"
                                primaryText={<LocalizedText textKey={TextKey.PasswordChangeSuccessMessage} />}
                            />
                            <LinkButton to="/Home/SignIn" icon={IconName.ArrowLeft} variant="primary" wide>
                                <LocalizedText textKey={TextKey.BackToLogin} />
                            </LinkButton>
                        </>
                    ) : (
                        <>
                            <LocalizedPageTitle textKey={TextKey.ResetPassword} />
                            <SetPasswordForm onFormSuccess={setIsSetSuccess} />
                        </>
                    )}
                </Stack>
            </OptimusProvider>
        </NewPublicFormWrapper>
    );
};
